import { Button } from "components/button"
import HamburgerIcon from "components/side-nav/menu-button/HamburgerIcon"
import React from "react"
import { useSideNav } from "../../hooks/useSideNav"
import "./header.module.scss"
import { AnchorNumber } from "components/anchor-number/AnchorNumber"
import { useGeneralSettings } from "hooks/useGeneralSettings"
import { useMainOfficeNumber } from "hooks/useMainOfficeNumber"
import { getPhoneIcon } from "assets/helper/icons"

interface HamburgerMenuProps {
  isHidden?: boolean
}

const HamburgerMenu = ({ isHidden = false }: HamburgerMenuProps) => {
  const { handleOpenNav, isNavOpen } = useSideNav()
  const { mainOfficeNumber } = useMainOfficeNumber({})
  const { trackingNumbers } = useGeneralSettings()
  const hiddenClassName = isHidden ? "fr-header__burger--hidden" : ""
  const windowAvailable = typeof window !== "undefined"
  return (
    <>
      {!isHidden && (
        <Button
          variant="flashy-icon"
          onClick={handleOpenNav}
          extraClassNames={`fr-header__burger ${
            isNavOpen ? "open" : ""
          } ${hiddenClassName}`}
          aria-label="open side menu"
          disabled={isHidden}
        >
          <HamburgerIcon />
        </Button>
      )}
      {isHidden &&
        trackingNumbers.length >= 1 &&
        windowAvailable &&
        window.innerWidth < 550 && (
          <a href={`tel: ${mainOfficeNumber}`}>
            <div className="fr-header__phone">{getPhoneIcon()}</div>
          </a>
        )}
    </>
  )
}

export default HamburgerMenu
